import * as React from "react";
import { SVGProps } from "react";

const SvgSixDiamonds = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 285 398"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M273.4 0H11.5S.5.3.5 14.8v367.6c0 14.5 11 14.8 11 14.8h261.9s11-.3 11-14.8V14.8C284.3.3 273.4 0 273.4 0Z"
      fill="#fff"
    />
    <mask
      id="six-diamonds_svg__b"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={214}
      width={285}
      height={184}
    >
      <path
        d="M167.9 214.4c-55.8 0-111.6 0-167.3.1v168c0 14.5 11 14.8 11 14.8h261.8s11-.3 11-14.8V214.4H167.9Z"
        fill="url(#six-diamonds_svg__a)"
      />
    </mask>
    <g mask="url(#six-diamonds_svg__b)">
      <path
        d="M167.9 214.4c-55.8 0-111.6 0-167.3.1v168c0 14.5 11 14.8 11 14.8h261.8s11-.3 11-14.8V214.4H167.9Z"
        fill="url(#six-diamonds_svg__c)"
      />
    </g>
    <mask
      id="six-diamonds_svg__e"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={285}
      height={199}
    >
      <path
        d="M.5 198.2c23.9 0 47.8 0 71.7.1 68.8 0 137.7 0 206.5.1h5.7V14.8c0-14.5-11-14.8-11-14.8H11.6S.6.3.6 14.8V198.2H.5Z"
        fill="url(#six-diamonds_svg__d)"
      />
    </mask>
    <g mask="url(#six-diamonds_svg__e)">
      <path
        d="M.5 198.2c23.9 0 47.8 0 71.7.1 68.8 0 137.7 0 206.5.1h5.7V14.8c0-14.5-11-14.8-11-14.8H11.6S.6.3.6 14.8V198.2H.5Z"
        fill="url(#six-diamonds_svg__f)"
      />
    </g>
    <mask
      id="six-diamonds_svg__h"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={5}
      y={0}
      width={280}
      height={398}
    >
      <path
        d="M283.8 14.8V382c0 14.5-11 14.8-11 14.8H10.7s-2.4-.1-4.9-1.6c2.8 2.1 5.8 2.2 5.8 2.2h261.9s11-.3 11-14.8V14.8c0-14.5-11-14.8-11-14.8h-.6c-.1 0 10.9.3 10.9 14.8Z"
        fill="url(#six-diamonds_svg__g)"
      />
    </mask>
    <g mask="url(#six-diamonds_svg__h)">
      <path
        d="M283.8 14.8V382c0 14.5-11 14.8-11 14.8H10.7s-2.4-.1-4.9-1.6c2.8 2.1 5.8 2.2 5.8 2.2h261.9s11-.3 11-14.8V14.8c0-14.5-11-14.8-11-14.8h-.6c-.1 0 10.9.3 10.9 14.8Z"
        fill="url(#six-diamonds_svg__i)"
      />
    </g>
    <mask
      id="six-diamonds_svg__k"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={280}
      height={398}
    >
      <path
        d="M1.1 382.5V15.4C1.1.9 12.1.6 12.1.6h262.1s2.4.1 4.9 1.6C276.3.1 273.3 0 273.3 0H11.4S.4.3.4 14.8v367.6c0 14.5 11 14.8 11 14.8h.6c.1.1-10.9-.2-10.9-14.7Z"
        fill="url(#six-diamonds_svg__j)"
      />
    </mask>
    <g mask="url(#six-diamonds_svg__k)">
      <path
        d="M1.1 382.5V15.4C1.1.9 12.1.6 12.1.6h262.1s2.4.1 4.9 1.6C276.3.1 273.3 0 273.3 0H11.4S.4.3.4 14.8v367.6c0 14.5 11 14.8 11 14.8h.6c.1.1-10.9-.2-10.9-14.7Z"
        fill="url(#six-diamonds_svg__l)"
      />
      <mask
        id="six-diamonds_svg__n"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={28}
        width={2}
        height={344}
      >
        <path
          d="M.5 28.7v342.6l.6-2.1V34.9c-.2-2-.4-4.1-.6-6.2Z"
          fill="url(#six-diamonds_svg__m)"
        />
      </mask>
      <g mask="url(#six-diamonds_svg__n)">
        <path
          d="M.5 28.7v342.6l.6-2.1V34.9c-.2-2-.4-4.1-.6-6.2Z"
          fill="url(#six-diamonds_svg__o)"
        />
      </g>
    </g>
    <path
      d="M34.8 74.3c-7.2-4-12.9-16.1-13.1-16.4-.2.4-5.9 12.5-13.1 16.4 7.2 4 12.9 16.1 13.1 16.4.2-.3 6-12.4 13.1-16.4ZM30 18.4v1.2c-2.6 0-4.9.6-6.9 1.7s-3.6 2.7-5 4.9c-1.3 2.1-2.2 4.7-2.8 7.6l.3.1c1.4-1 2.8-1.7 4.2-2.2 1.4-.5 2.8-.7 4.4-.7 1.9 0 3.5.4 4.8 1.2 1.3.8 2.3 2 3 3.5.7 1.5 1 3.3 1 5.3 0 2.2-.4 4.1-1.3 5.8-.8 1.7-2.1 3-3.9 3.9-1.7 1-3.9 1.4-6.5 1.4-3.7 0-6.4-1.1-8.3-3.4-1.9-2.3-2.8-5.6-2.8-10.1 0-3 .5-5.8 1.4-8.4.9-2.6 2.3-4.9 4-6.8 1.7-1.9 3.7-3.5 6-4.6 2.3-1.1 4.7-1.7 7.2-1.9l1.2 1.5Zm-7.5 15.2c-.8 0-1.6.1-2.4.3-.8.2-1.5.5-2.1.8-.7.4-1.3.8-2 1.3-.2.2-.3.4-.5.6-.2.3-.3.7-.3 1.2-.1.5-.1 1.3-.1 2.4 0 3.2.5 5.6 1.6 7.3 1.1 1.7 2.7 2.5 4.9 2.5 1.3 0 2.3-.2 3.2-.7.9-.4 1.5-1 2.1-1.8.5-.8.9-1.7 1.1-2.7.2-1 .3-2.1.3-3.3 0-2.5-.5-4.4-1.5-5.8-1-1.4-2.4-2.1-4.3-2.1ZM248.5 322.2c7.2 4 12.9 16.1 13.1 16.4.2-.4 5.9-12.5 13.1-16.4-7.2-4-12.9-16.1-13.1-16.4-.2.3-5.9 12.4-13.1 16.4ZM253.3 378.1v-1.2c2.6 0 4.9-.6 6.8-1.7 2-1.1 3.6-2.7 5-4.9 1.3-2.1 2.2-4.7 2.8-7.6l-.3-.1c-1.4 1-2.8 1.7-4.2 2.2-1.4.5-2.8.7-4.4.7-1.9 0-3.5-.4-4.8-1.2-1.3-.8-2.3-2-3-3.5-.7-1.5-1-3.3-1-5.3 0-2.2.4-4.1 1.3-5.8.8-1.7 2.1-3 3.9-3.9 1.7-1 3.9-1.4 6.5-1.4 3.7 0 6.4 1.1 8.3 3.4 1.9 2.3 2.8 5.6 2.8 10.1 0 3-.5 5.8-1.4 8.4-.9 2.6-2.3 4.9-4 6.8-1.7 1.9-3.7 3.5-6 4.6-2.3 1.1-4.7 1.7-7.2 1.9l-1.1-1.5Zm7.5-15.2c.8 0 1.6-.1 2.4-.3.8-.2 1.5-.5 2.1-.8.7-.3 1.3-.8 2-1.3.2-.2.3-.4.5-.6.2-.3.3-.7.3-1.2.1-.5.1-1.3.1-2.4 0-3.2-.5-5.6-1.6-7.3-1.1-1.7-2.7-2.5-4.9-2.5-1.3 0-2.3.2-3.2.7-.9.4-1.5 1-2.1 1.8-.5.8-.9 1.7-1.1 2.7-.2 1-.3 2.1-.3 3.3 0 2.5.5 4.4 1.5 5.8 1 1.4 2.5 2.1 4.3 2.1ZM221.1 317.8c-14.3-7.9-25.7-31.9-26-32.6-.4.8-11.8 24.7-26 32.6 14.3 7.9 25.7 31.9 26 32.6.3-.8 11.8-24.7 26-32.6ZM221.1 79.4c-14.3-7.9-25.7-31.9-26-32.6-.4.8-11.8 24.7-26 32.6 14.3 7.9 25.7 31.9 26 32.6.3-.7 11.8-24.7 26-32.6ZM221.1 199.2c-14.3-7.9-25.7-31.9-26-32.6-.4.8-11.8 24.7-26 32.6 14.3 7.9 25.7 31.9 26 32.6.3-.7 11.8-24.7 26-32.6ZM116.3 317.8c-14.3-7.9-25.7-31.9-26-32.6-.4.8-11.8 24.7-26 32.6 14.2 7.9 25.7 31.9 26 32.6.3-.8 11.7-24.7 26-32.6ZM116.3 79.4c-14.3-7.9-25.7-31.9-26-32.6-.4.8-11.8 24.7-26 32.6 14.2 7.9 25.7 31.9 26 32.6.3-.7 11.7-24.7 26-32.6ZM116.3 199.2c-14.3-7.9-25.7-31.9-26-32.6-.4.8-11.8 24.7-26 32.6 14.2 7.9 25.7 31.9 26 32.6.3-.7 11.7-24.7 26-32.6Z"
      fill="#FF2601"
    />
    <defs>
      <radialGradient
        id="six-diamonds_svg__a"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(138.041 -135.451) scale(574.543)"
      >
        <stop offset={0.616} />
        <stop offset={0.752} stopColor="#020202" />
        <stop offset={0.804} stopColor="#090909" />
        <stop offset={0.841} stopColor="#151515" />
        <stop offset={0.872} stopColor="#262626" />
        <stop offset={0.899} stopColor="#3C3C3C" />
        <stop offset={0.922} stopColor="#585858" />
        <stop offset={0.944} stopColor="#797979" />
        <stop offset={0.963} stopColor="#9F9F9F" />
        <stop offset={0.982} stopColor="#CBCBCB" />
        <stop offset={0.998} stopColor="#F9F9F9" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="six-diamonds_svg__c"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(138.041 -135.451) scale(574.543)"
      >
        <stop offset={0.616} stopColor="#fff" />
        <stop offset={0.788} stopColor="#FDFDFD" />
        <stop offset={0.854} stopColor="#F6F6F6" />
        <stop offset={0.901} stopColor="#EAEAEA" />
        <stop offset={0.94} stopColor="#D9D9D9" />
        <stop offset={0.974} stopColor="#C3C3C3" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="six-diamonds_svg__d"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(143.725 366.656) scale(411.698)"
      >
        <stop offset={0.616} />
        <stop offset={0.71} stopColor="#020202" />
        <stop offset={0.762} stopColor="#0A0A0A" />
        <stop offset={0.805} stopColor="#181818" />
        <stop offset={0.842} stopColor="#2C2C2C" />
        <stop offset={0.875} stopColor="#464646" />
        <stop offset={0.906} stopColor="#656565" />
        <stop offset={0.935} stopColor="#8A8A8A" />
        <stop offset={0.963} stopColor="#B6B6B6" />
        <stop offset={0.988} stopColor="#E5E5E5" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="six-diamonds_svg__f"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(143.725 366.656) scale(411.698)"
      >
        <stop offset={0.616} stopColor="#fff" />
        <stop offset={0.747} stopColor="#FDFDFD" />
        <stop offset={0.821} stopColor="#F5F5F5" />
        <stop offset={0.88} stopColor="#E7E7E7" />
        <stop offset={0.932} stopColor="#D3D3D3" />
        <stop offset={0.978} stopColor="#BABABA" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="six-diamonds_svg__g"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-11.609 -.179) scale(457.13)"
      >
        <stop offset={0.099} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="six-diamonds_svg__i"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-11.609 -.179) scale(457.13)"
      >
        <stop offset={0.099} stopColor="#fff" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="six-diamonds_svg__j"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(78.05 115.635) scale(389.352)"
      >
        <stop />
        <stop offset={0.007} stopColor="#090909" />
        <stop offset={0.048} stopColor="#373737" />
        <stop offset={0.093} stopColor="#626262" />
        <stop offset={0.142} stopColor="#888" />
        <stop offset={0.195} stopColor="#A8A8A8" />
        <stop offset={0.254} stopColor="#C4C4C4" />
        <stop offset={0.32} stopColor="#DADADA" />
        <stop offset={0.397} stopColor="#EBEBEB" />
        <stop offset={0.493} stopColor="#F6F6F6" />
        <stop offset={0.627} stopColor="#FDFDFD" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="six-diamonds_svg__l"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(78.05 115.635) scale(389.352)"
      >
        <stop stopColor="#fff" />
        <stop offset={0.141} stopColor="#fff" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="six-diamonds_svg__m"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(-457.214 0 0 -457.232 296.621 -.18)"
      >
        <stop offset={0.099} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="six-diamonds_svg__o"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(-457.214 0 0 -457.232 296.621 -.18)"
      >
        <stop offset={0.099} stopColor="#fff" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
    </defs>
  </svg>
);

export default SvgSixDiamonds;
